import {
  GetPollsByUUIDResponse,
  GetPollsItemResponse,
  GetPollsResponse,
  PostPollsResponse,
  PutPollsResponse,
} from '@/services/response/polls';
import { Polls } from '@/model/polls';

export class PollsConverter {
  static toDomainFromPollItemResponse(response: GetPollsItemResponse): Polls {
    return {
      uuid: response.uuid,
      question: response.question,
      identifier: response.identifier,
      status: response.status,
      interactivity: response.interactivity,
      closing_date: response.closing_date,
      allow_multiple_votes: response.allow_multiple_votes,
      show_partial_results: response.show_partial_results,
      disable_comments: response.disable_comments,
      enable_home: response.enable_home,
      total_participants: response.total_participants,
      total_comments: response.total_comments,
      total_votes: response.total_votes,
      poll_options: response.poll_options.map(option => ({
        uuid: option.uuid,
        option_text: option.option_text,
        votes: option.votes,
        image_url: option.image_url ?? '',
        created_at: option.created_at,
        updated_at: option.updated_at,
      })),
      team_uuid: response?.team_uuid,
      team_name: response?.team_name,
      team_image: response?.team_image,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPollsPaginatedResponse(response: GetPollsResponse): Polls[] {
    return response.data.map(PollsConverter.toDomainFromPollItemResponse);
  }

  static toDomainFromPutPollsResponse(response: PutPollsResponse): Polls {
    return {
      uuid: response.uuid,
      question: response.question,
      identifier: response.identifier,
      status: response.status,
      interactivity: response.interactivity,
      closing_date: response.closing_date,
      allow_multiple_votes: response.allow_multiple_votes,
      show_partial_results: response.show_partial_results,
      disable_comments: response.disable_comments,
      enable_home: response.enable_home,
      total_participants: response.total_participants,
      total_comments: response.total_comments,
      total_votes: response.total_votes,
      poll_options: response.poll_options.map(option => ({
        uuid: option.uuid,
        option_text: option.option_text,
        votes: option.votes,
        image_url: option.image_url ?? '',
        created_at: option.created_at,
        updated_at: option.updated_at,
      })),
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromGetPollsByUUIDResponse(response: GetPollsByUUIDResponse): Polls {
    return {
      uuid: response.uuid,
      question: response.question,
      identifier: response.identifier,
      status: response.status,
      interactivity: response.interactivity,
      closing_date: response.closing_date,
      closed_at: response.closed_at,
      allow_multiple_votes: response.allow_multiple_votes,
      show_partial_results: response.show_partial_results,
      disable_comments: response.disable_comments,
      enable_home: response.enable_home,
      total_participants: response.total_participants,
      total_comments: response.total_comments,
      total_votes: response.total_votes,
      poll_options: response.poll_options.map(option => ({
        uuid: option.uuid,
        option_text: option.option_text,
        votes: option.votes,
        image_url: option.image_url ?? '',
        created_at: option.created_at,
        updated_at: option.updated_at,
      })),
      team_uuid: response?.team_uuid,
      team_name: response?.team_name,
      team_image: response?.team_image,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPostPollsResponse(response: PostPollsResponse): Polls {
    return {
      uuid: response.uuid,
      question: response.question,
      identifier: response.identifier,
      status: response.status,
      interactivity: response.interactivity,
      closing_date: response.closing_date,
      allow_multiple_votes: response.allow_multiple_votes,
      show_partial_results: response.show_partial_results,
      disable_comments: response.disable_comments,
      enable_home: response.enable_home,
      total_participants: response.total_participants,
      total_comments: response.total_comments,
      total_votes: response.total_votes,
      poll_options: response.poll_options.map(option => ({
        uuid: option.uuid,
        option_text: option.option_text,
        votes: option.votes,
        image_url: option.image_url ?? '',
        created_at: option.created_at,
        updated_at: option.updated_at,
      })),
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }
}
